import React from "react";
import { connect, ConnectedProps } from "react-redux";
import { closeDialog } from "../../../store/actions";

interface IProps {
  question: string;
  cancel: string;
  cancelAction?: any;
  confirm: string;
  confirmAction: any;
}

const mapDispatchToProps = (dispatch: any) => ({
  closeDialogDispatch: () => dispatch(closeDialog())
});

const connector = connect(null, mapDispatchToProps);

const ConfirmDialog = ({
  question,
  cancel,
  cancelAction,
  confirm,
  confirmAction,
  closeDialogDispatch
}: IProps & ConnectedProps<typeof connector>) => (
  <>
    <div className={"dialog-content"}>
      <table className="table">
        <tr>
          <td>
            <strong>
              {question}
            </strong>
          </td>
        </tr>
      </table>
    </div>
    <div className={"dialog-footer"}>
      <a
        onClick={cancelAction || closeDialogDispatch}
        className="btn btn-blank btn-no-width"
      >
        {cancel}
      </a>
      <a
        onClick={confirmAction}
        className="btn btn-blank btn-no-width"
      >
        {confirm}
      </a>
    </div>
  </>
)

export default connector(ConfirmDialog);
